import ImgCrop from "antd-img-crop";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import { Card, Button, Upload, message } from "antd";
import ImageUploadThumbnailIcon from "../../common/icons/imageUploadThumbnail";
import { usePreviousState } from "../../../utils/customHooks";
import { defaultCompanyCoverPhoto } from "../../../utils/constants";
import { updateCompanyCoverPhoto } from "../../../actions/companyActions";
import GalkButton from "../../common/component/button";
import { EditPenOnPaperRightHandIcon, RefreshIcon } from "../../common/icons";

import "./style.css";

const getSrcFromFile = (file) => {
	return new Promise((resolve) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);
		reader.onloadend = () => resolve(reader.result);
	});
};

const CoverPhoto = ({
	coverPhoto,
	updateCompanyCoverPhoto,
	isActionProgress,
	setCompletionBool,
}) => {
	const prevActionInProgressValue = usePreviousState(isActionProgress);

	const [photo, setCoverPhoto] = useState(coverPhoto);
	const [coverPhotoObject, setCoverPhotoObject] = useState(null);
	const [isEditable, setIsEditable] = useState(false);
	const [fileList, setFileList] = useState([]);
	const { t } = useTranslation();

	useEffect(() => {
		setCoverPhoto(coverPhoto);
	}, [coverPhoto]);

	useEffect(() => {
		if (!isActionProgress && prevActionInProgressValue) {
			resetAll();
		}
	}, [isActionProgress]); // eslint-disable-line react-hooks/exhaustive-deps

	const resetAll = () => {
		setIsEditable(false);
		setCoverPhotoObject(null);
	};

	const fetchFileData = async (file) => {
		if (file) {
			// const file = info.file.originFileObj;

			const isAcceptableFileType =
				file.type === "image/jpeg" ||
				file.type === "image/svg+xml" ||
				file.type === "image/gif" ||
				file.type === "image/png";

			if (!isAcceptableFileType) {
				message.error("You can only upload jpeg/png/svg/gif file!");
			}

			const isLt10M = file.size / 1024 / 1024 < 10;

			if (!isLt10M) {
				message.error("Image must be smaller than 10MB!");
			}

			if (isAcceptableFileType && isLt10M) {
				const url = await getSrcFromFile(file);
				setCoverPhoto(url);
				setCoverPhotoObject(file);
			}
		} else {
			setCoverPhotoObject(null);
		}

		return false;
	};

	const handleCoverPhotoUploadChange = (info) => {};

	const updateCoverPhoto = () => {
		if (coverPhotoObject) {
			updateCompanyCoverPhoto(coverPhotoObject);
			setCompletionBool("coverPhoto");
		} else {
			message.error("Please selectba new file and then click on save.");
		}
	};

	return (
		<Card
			type="inner"
			title={`${t("corporate_coverphoto")}`}
			extra={
				isEditable ? (
					<div style={{ display: "flex", gap: "16px" }}>
						<GalkButton
							type="secondary"
							height={36}
							additionalStyle={{ padding: "13px 16px" }}
							onClick={resetAll}
							disabled={isActionProgress}
						>
							{`${t("cancel")}`}
						</GalkButton>
						<GalkButton
							type="primary"
							height={36}
							additionalStyle={{ padding: "13px 16px" }}
							onClick={updateCoverPhoto}
							disabled={!coverPhotoObject}
							loading={isActionProgress}
						>
							<RefreshIcon width={14} height={14} />
							{`${t("save")}`}
						</GalkButton>
					</div>
				) : (
					<GalkButton
						type="default"
						height={36}
						additionalStyle={{ padding: "13px 16px" }}
						onClick={() => setIsEditable(true)}
					>
						<EditPenOnPaperRightHandIcon width={14} height={14} />
						{`${t("edit")}`}
					</GalkButton>
				)
			}
		>
			<div className="companyDetails_coverPhoto_container">
				<div className="companyDetails_coverPhoto_uploadControl">
					{isEditable ? (
						<ImgCrop aspect={4 / 1} rotationSlider aspectSlider showReset>
							<Upload
								name="avatar"
								// listType="picture-circle"
								// className="avatar-uploader"
								showUploadList={false}
								beforeUpload={fetchFileData}
								onChange={handleCoverPhotoUploadChange}
								maxCount={1}
								disabled={!isEditable}
								fileList={fileList}
							>
								<img
									className="editableImage"
									src={photo || defaultCompanyCoverPhoto}
									alt="coverPhoto"
								/>
								<div className="uploadText">
									<ImageUploadThumbnailIcon height={54} width={54} />
									<br />
									<span>Image should be less than 10mb in size</span>
								</div>
							</Upload>
						</ImgCrop>
					) : (
						<>
							<img
								className="notEditableImage"
								src={photo || defaultCompanyCoverPhoto}
								alt="avatar"
							/>
						</>
					)}
				</div>
			</div>
		</Card>
	);
};
const mapStateToProps = (state) => ({
	coverPhoto: state.company.company ? state.company.company.coverPhoto : null,
	isActionProgress: state.company.actionInProgress,
});

export default connect(mapStateToProps, { updateCompanyCoverPhoto })(
	CoverPhoto
);
